"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteFlatType = void 0;
var FavoriteFlatType;
(function (FavoriteFlatType) {
    FavoriteFlatType["MINIMALIST"] = "MINIMALIST";
    FavoriteFlatType["FAMILY"] = "FAMILY";
    FavoriteFlatType["BIG_HOUSES"] = "BIG_HOUSES";
})(FavoriteFlatType = exports.FavoriteFlatType || (exports.FavoriteFlatType = {}));
//# sourceMappingURL=FavoriteFlatType.js.map